module.exports = __webpack_public_path__ + "img/tratamiento.eb94e607.png";